export const MAX_SEGMENT = 5;
